import { Typography } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export default function Header() {
  return (
    <div className="flex flex-row items-center gap-5">
      <Svg
        name={SvgEnum.HisFolderClock}
        color={HNSColors.primary[500]}
        sx={{ height: "24px", width: "24px" }}
      />
      <Typography className="text-[20px] font-semibold" style={{ color: HNSColors.primary[500] }}>
        Follow - Ups History
      </Typography>
    </div>
  );
}
